<template>
  <div class="search-icon" @click="open()">
    <router-link :to="{name: 'searchPage'}" class="h-icon">
      <ShoppingSearchIcon title="Szukaj" />
      <span class="role">szukaj</span>
    </router-link>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ShoppingSearchIcon from "vue-material-design-icons/ShoppingSearch.vue";

export default {
  components: {
    ShoppingSearchIcon
  },
  computed: {
    ...mapState({
      searchBlock: state => state.searchBlock
    })
  },
  methods: {
    open() {
      // this.$store.dispatch("openSearchBlock");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/src/button/SearchIcon.vue